import React from 'react';
import EmployeeProfileFormFields from '../../../components/profile/EmployeeProfileFormFields';

const AddEmployeePage = ({
    form,
    onChange,
    onSubmit,
    onCancel,
    submitting,
    hasCompany,
    backendToken,
    inputClass,
}) => (
    <div className="space-y-6">
        <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center gap-2 text-sm font-medium text-zinc-600 transition-colors hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white"
        >
            <i className="fa-solid fa-arrow-left text-xs" aria-hidden />
            Back to employees
        </button>

        <div className="space-y-1">
            <p className="text-xs uppercase tracking-wide text-zinc-500 dark:text-zinc-500">
                Organization
            </p>
            <h3 className="text-2xl font-bold tracking-tight text-zinc-900 dark:text-white">
                Add employee
            </h3>
            <p className="max-w-2xl text-sm text-zinc-600 dark:text-zinc-400">
                Add a team member as <strong>salaried</strong> (monthly payroll) or{' '}
                <strong>freelance</strong> (paid per task or milestone). Wallet address is
                required; compensation depends on employment type (salaried salary must be
                greater than zero).
            </p>
        </div>

        <div className="rounded-2xl border border-teal-200 bg-white p-6 shadow-sm md:rounded-3xl md:p-8 dark:border-teal-900/40 dark:bg-zinc-950/50 dark:shadow-none">
            <div className="mb-6 flex items-start gap-3 border-b border-zinc-200 pb-4 dark:border-zinc-800">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-teal-100 text-xs font-bold text-teal-800 ring-1 ring-teal-200 dark:bg-teal-900/50 dark:text-teal-200 dark:ring-teal-800">
                    1
                </span>
                <div>
                    <h4 className="text-base font-semibold text-zinc-900 dark:text-white">
                        Employee details
                    </h4>
                    <p className="mt-0.5 text-xs text-zinc-600 dark:text-zinc-400">
                        Name and wallet are required. Salaried employees need a monthly
                        salary greater than zero.
                    </p>
                </div>
            </div>

            <form onSubmit={onSubmit} className="space-y-6">
                <EmployeeProfileFormFields
                    form={form}
                    onChange={onChange}
                    inputClass={inputClass}
                    backendToken={backendToken}
                    disabled={submitting}
                    showWallet
                />

                {!hasCompany ? (
                    <p className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-200">
                        Create your company profile before adding employees.
                    </p>
                ) : null}

                <div className="flex flex-wrap items-center justify-end gap-3 border-t border-zinc-200 pt-6 dark:border-zinc-800">
                    <button
                        type="button"
                        onClick={onCancel}
                        disabled={submitting}
                        className="rounded-xl border border-zinc-300 bg-zinc-100 px-4 py-2.5 text-sm font-semibold text-zinc-800 transition-colors hover:border-zinc-400 hover:bg-zinc-200 disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-800/70 dark:text-zinc-200 dark:hover:border-zinc-500 dark:hover:bg-zinc-700/80"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={submitting || !hasCompany}
                        className="inline-flex items-center gap-2 rounded-xl bg-teal-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-teal-500 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-teal-600 dark:hover:bg-teal-500"
                    >
                        {submitting ? (
                            <>
                                <i className="fa-solid fa-spinner fa-spin text-xs" />
                                Saving…
                            </>
                        ) : (
                            <>
                                <i className="fa-solid fa-user-plus text-xs" />
                                Add employee
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    </div>
);

export default AddEmployeePage;
